import { dateFormat } from "utils/dayPickerDataFormatting";

const formatDate = (value) => dateFormat(value, "Choose Date");

export default formatDate;
